var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { createSlice } from '@reduxjs/toolkit';
export var initialState = {
    phone: '',
    email: '',
    profileApiError: ''
};
var profileDataSlice = createSlice({
    name: 'profileData',
    initialState: initialState,
    reducers: {
        setContactInfo: function (state, action) {
            return __assign(__assign({}, state), action.payload);
        },
        setProfileApiError: function (state, _a) {
            var profileApiError = _a.payload;
            return __assign(__assign({}, state), { profileApiError: profileApiError });
        }
    }
});
export var setContactInfo = (_a = profileDataSlice.actions, _a.setContactInfo), setProfileApiError = _a.setProfileApiError;
export default profileDataSlice.reducer;
